module.exports = __webpack_public_path__ + "static/chess_1-b872a4fbd1ac34d05490c2080bed86d8.png";